import React, { useContext } from 'react';
import { updateThreshold } from 'flow/store/redux/thunks/thresholdUpdates';
import RHSTextField from './RHSTextField';
import { useAppDispatch } from '~/store/reduxHooks';
import { ThresholdContext } from '../context';

interface RHSCreatableProps {
  shouldUseDefaultString: boolean;
  values: string[];
}

const RHSCreatable = ({
  shouldUseDefaultString,
  values,
}: RHSCreatableProps) => {
  const dispatch = useAppDispatch();
  const { populatedThreshold } = useContext(ThresholdContext);

  const onChange = (newValue: string) => {
    dispatch(updateThreshold.rightValue(populatedThreshold.publicId, newValue));
  };

  return (
    <RHSTextField
      onChange={onChange}
      shouldUseDefaultString={shouldUseDefaultString}
      value={values[0]}
    />
  );
};

export default RHSCreatable;

